import * as React from "react";

function MapIcon(props) {
  return (
    <svg
      width={17}
      height={16}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={props.isclicked ? "#f4f1de" : "#e07a5f"}
      >
        <path d="M0 2.121L4.52.001v13.81L0 15.941V2.121zM10.89 2.121L6.11.001v13.81l4.78 2.13V2.121zM12.48 2.121L17 .001v13.81l-4.52 2.13V2.121z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill={props.isclicked ? "#f4f1de" : "#e07a5f"}
            d="M0 0h17v15.94H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default MapIcon;
